import Elements from "./elements";

var DOC = document;

var SpinnerInitializer = function (el, options) {

	var SPINNER = {

		buttons: {

			elements: null,

			onClick: function (e) {
				var $this = $(this);
				var val = SPINNER.input.value;
				var type = 1;

				e.preventDefault();

				if ($this.hasClass(options.classNames.buttons.decrement)) {
					val = val - 1;
					type = 1;

				} else if ($this.hasClass(options.classNames.buttons.increment)) {
					val = val + 1;
					type = 2;

				} else {
					return;
				}
				val = SPINNER.input.set(val);

				SPINNER.limit.toggle();

				if (type === 1) {
					if ('onDecrement' in options && typeof options.onDecrement === 'function') {
						options.onDecrement(this, val, el);
					}
					return;
				}

				if ('onIncrement' in options && typeof options.onIncrement === 'function') {
					options.onIncrement(this, val, el);
				}

			},

			destroy: function () {
				var els = SPINNER.buttons.elements;
				var i = 0;

				if (els === null) {
					return;
				}

				for (i; i < els.length; i++) {
					els[i].removeEventListener('click', SPINNER.buttons.onClick);
				}
				SPINNER.buttons.elements = null;

			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.buttons.main);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				SPINNER.buttons.elements = [];

				for (i; i < els.length; i++) {
					SPINNER.buttons.elements[SPINNER.buttons.elements.length] = els[i];
					els[i].addEventListener('click', SPINNER.buttons.onClick);

				}

			}

		},

		input: {

			elements: null,

			min: 0,

			max: 99999,

			value: 0,

			set: function (val) {
				var self = SPINNER.input;
				var els = self.elements;
				var i = 0;

				if (els === null) {
					return;
				}

				if (val < self.min) {
					val = self.min;
				}

				if (val > self.max) {
					val = self.max;
				}

				for (i; i < els.length; i++) {
					els[i].value = val;
				}
				self.value = val;

			},

			onChange: function () {
				var self = SPINNER.input;
				var val = parseFloat(this.value);

				if (typeof val !== 'number') {
					return;
				}

				if (val < self.min) {
					this.value = val = self.min;
				}

				if (val > self.max) {
					this.value = val = self.max;
				}

				self.value = val;

				SPINNER.limit.toggle();

				if (!('onChange' in options) || typeof options.onChange !== 'function') {
					return;
				}

				options.onChange(this, val, el);

			},

			destroy: function () {
				var els = SPINNER.input.elements;
				var i = 0;

				if (els === null) {
					return;
				}

				for (i; i < els.length; i++) {
					els[i].removeEventListener('change', SPINNER.input.onChange);

				}
				SPINNER.input.elements = null;
				SPINNER.input.min = 0;
				SPINNER.input.max = 99999;
				SPINNER.input.value = 0;


			},

			/**
			 * @todo	initialiser le min, max et la value
			 * @returns
			 */
			construct: function () {
				var els = el.getElementsByClassName(options.classNames.input);
				var i = 0;
				var min, max, val;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				SPINNER.input.elements = [];

				for (i; i < els.length; i++) {
					SPINNER.input.elements[SPINNER.input.elements.length] = els[i];

					min = parseFloat(els[i].getAttribute('min'));
					max = parseFloat(els[i].getAttribute('max'));
					val = parseFloat(els[i].value);

					if (typeof min === 'number' && !isNaN(min)) {
						SPINNER.input.min = min;
					}

					if (typeof max === 'number' && !isNaN(max)) {
						SPINNER.input.max = max;
					}

					if (typeof val === 'number' && !isNaN(val)) {
						SPINNER.input.value = val;
					}

					if (SPINNER.input.min >= SPINNER.input.max) {
						SPINNER.input.max = SPINNER.input.min;
					}

					els[i].addEventListener('change', SPINNER.input.onChange);
				}

			},
		},


		limit: {

			elements: null,

			toggle: function () {
				const classNames = {
					show: options.classNames.limit + '--show',
					disable: options.classNames.buttons.main + '--disabled'
				};

				const els = SPINNER.limit.elements;
				const btns = SPINNER.buttons.elements;
				const max = SPINNER.input.max;
				const min = SPINNER.input.min;
				const val = SPINNER.input.value;
				const isMax = val >= max;
				const isMin = val <= min;
				var i = 0;
				var $btn;

				if (els !== null) {
					for (i; i < els.length; i++){
						if (isMax) {
							$(els[i]).addClass(classNames.show);
							continue;
						}
						$(els[i]).removeClass(classNames.show);
					}
				}

				if (btns !== null) {
					i = 0;

					for (i; i < btns.length; i++){
						$btn = $(btns[i]);

						if ((isMax && $btn.hasClass(options.classNames.buttons.increment)) || (isMin && $btn.hasClass(options.classNames.buttons.decrement)) ) {
							$btn.addClass(classNames.disable).attr('disabled', 'disabled');
							continue;
						}
						$btn.removeClass(classNames.disable).removeAttr('disabled');
					}
				}


			},

			destroy: function () {
				SPINNER.limit.elements = null;

			},

			/**
			 * @todo	initialiser le min, max et la value
			 * @returns
			 */
			construct: function () {
				var els = el.getElementsByClassName(options.classNames.limit);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}
				SPINNER.limit.elements = [];

				for (i; i < els.length; i++) {
					SPINNER.limit.elements[SPINNER.limit.elements.length] = els[i];
				}

			},
		},

		destroy: function () {
			SPINNER.buttons.destroy();
			SPINNER.input.destroy();
			SPINNER.limit.destroy();
		}

	};

	SPINNER.buttons.construct();
	SPINNER.input.construct();
	SPINNER.limit.construct();

	SPINNER.limit.toggle();

	return {
		destroy: SPINNER.destroy
	};
}

/**	Constructeur
 * @param	{object}	options		Optionnel, tableau des options :
 * 									- prefix
 * 									- onChange
 * 									- onIncrement
 * 									- onDecrement
 * 									- parentNode
 * @returns
 */
var Spinner = function (options) {
	var base;
	var parentNode = DOC;

	const CORE = {

		instances: null,

		reload: function () {
			CORE.destroy();
			return Spinner(options);

		},

		destroy: function () {
			const instances = CORE.instances;
			let i = 0;

			if (instances === null || !instances.length) {
				return;
			}

			for (i; i < instances.length; i++){
				instances[i].destroy();
			}

		},

		construct: function () {
			CORE.instances = [];

			Elements({
				selector: options.classNames.holder,
				element: parentNode,
				onElement: function (el) {
					CORE.instances[CORE.instances.length] = SpinnerInitializer(el, options);

				}
			});

		}


	};

	if (typeof options !== 'object' || options == null) {
		options = {};
	}
	options.prefix = 'prefix' in options && typeof options.prefix === 'string' ? options.prefix : 'sp';
	base = options.prefix + '-spinner';
	options.classNames = {
		holder: base,
		input: base + '__input',
		limit: base + '__max',
		buttons: {
			main: base + '__btn',
			decrement: base + '__btn--less',
			increment: base + '__btn--more',
		},
	};

	if ('parentNode' in options && typeof options.parentNode === 'object' && options.parentNode !== null && 'nodeName' in options.parentNode) {
		parentNode = options.parentNode;
	}
	CORE.construct();

	return {
		elements: CORE.elements,
		reload: CORE.reload,
		destroy: CORE.destroy
	};

};

export default Spinner;